import { Alert, Box } from '@mui/material';
import Div100vh from 'react-div-100vh';

export interface ErrorProps {
  error: string;
}

export const Error: React.FC<ErrorProps> = ({ error }) => (
  <Div100vh>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      <Alert severity="error">{error}</Alert>
    </Box>
  </Div100vh>
);
